import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {OrderModel} from "../../models/order.model";

@Injectable({providedIn: 'root'})
export class OrdersHttpService {

  private base_url = `/oms/orders-v2`;

  constructor(@Inject(HttpClient) private http: HttpClient) {}

  getOrders(params?: any): Observable<{ list: OrderModel[], cursor?: string }> {
    return this.http.get<{ list: OrderModel[], cursor?: string }>(this.base_url, {params});
  }

}
